var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b941bd5f5c954fe1611eda424f161144b89f0939"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["admin-app@tucar-spa"]={id:"b941bd5f5c954fe1611eda424f161144b89f0939"};
      